//@flow
import { hmset, hget, hdelAll } from '../hash'
import type { SetAction } from '../hash'
import type { AppState } from '../../core/types'

const DOMAIN = 'comms'

export const COMM_STATES = {
  NotAsked: 'COMM/NOT_ASKED',
  Loading: 'COMM/LOADING',
  Failure: 'COMM/FAILURE',
  Success: 'COMM/SUCCESS'
}

type CommState =
  | 'COMM/NOT_ASKED'
  | 'COMM/LOADING'
  | 'COMM/FAILURE'
  | 'COMM/SUCCESS'

export const startCommunication = (resource: string): SetAction =>
  hmset(DOMAIN, {
    [resource]: COMM_STATES.Loading,
    [resource + '_start']: Date.now()
  })

export const endCommunication = (
  resource: string,
  success: boolean = true
): SetAction =>
  hmset(DOMAIN, {
    [resource]: success ? COMM_STATES.Success : COMM_STATES.Failure,
    [resource + '_end']: Date.now()
  })

export const clearCommunication = (resource: string) =>
  hmset(DOMAIN, {
    [resource]: COMM_STATES.NotAsked,
    [resource + '_start']: undefined,
    [resource + '_end']: undefined
  })

export const isCommInProgress = (resource: string, state: AppState): boolean =>
  Boolean(hget(DOMAIN, resource, state) === COMM_STATES.Loading)

export const isCommCompleted = (resource: string, state: AppState): boolean =>
  isCommSuccess(resource, state) || isCommFailure(resource, state)

export const isCommSuccess = (resource: string, state: AppState): boolean =>
  Boolean(hget(DOMAIN, resource, state) === COMM_STATES.Success)

export const isCommFailure = (resource: string, state: AppState): boolean =>
  Boolean(hget(DOMAIN, resource, state) === COMM_STATES.Failure)

export const getCommunicationState = (
  resource: string,
  state: AppState
): CommState => hget(DOMAIN, resource, state) || COMM_STATES.NotAsked

export const cleanAllCommunications = () => hdelAll(DOMAIN)

export const getLastRequestTime = (resource: string, state: AppState): number =>
  hget(DOMAIN, `${resource}_end`, state) || 0

export const shouldRequest = (
  resource: string,
  minDelay: number,
  state: AppState
): boolean => {
  const resSuccess = isCommCompleted(resource, state)
  const lastFetched = getLastRequestTime(resource, state)
  const shouldRefetch = Date.now() - lastFetched >= minDelay
  return resSuccess && !shouldRefetch
}



// WEBPACK FOOTER //
// ./src/modules/communication/index.js